/**
 * @module business 
 *  Apis must need auth details to trigger url - AuthApi
 */

import Env from '@/env';
const apiVersion = 'api';
import AuthApis from '@/controllers/AuthApis';
import ApiHelper from '@/controllers/ApiHelpers';

export default {
  /**
   * Fetch all location holiday hours
   */
  fetchAllLocationHolidayHours() {
    const url = `${Env.loginUrl}/${apiVersion}/location-holidays/all`;
    return AuthApis.getApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * Add location holiday hours
   */
  addNewLocationHolidayHours(data) {
    const url = `${Env.loginUrl}/${apiVersion}/location-holidays/create`;
    return AuthApis.postApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * Update location holiday hours
   */
  updateLocationHolidayHours(locationHolidayId, data) {
    const url = `${Env.loginUrl}/${apiVersion}/location-holidays/${locationHolidayId}/update`;
    return AuthApis.patchApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * Delete location holiday hours
   */
  deleteLocationHolidayHours(locationHolidayId) {
    const url = `${Env.loginUrl}/${apiVersion}/location-holidays/${locationHolidayId}/remove`;
    return AuthApis.deleteApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


}